import React, { useState } from 'react';
import './Products.css';
import './AllSellStyles.css';
import './CommonStyles.css';
import { exportToCSV, exportToExcel, exportToPDF, printPage } from './exportUtils';

const TaxReport = () => {
    const [activeSubTab, setActiveSubTab] = useState('input');
    const [entriesPerPage, setEntriesPerPage] = useState(25);
    const [searchTerm, setSearchTerm] = useState('');
    const [showExportDropdown, setShowExportDropdown] = useState(false);
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');

    const subTabs = [
        { id: 'input',   label: 'Input Tax',   icon: 'fa-arrow-circle-down' },
        { id: 'output',  label: 'Output Tax',  icon: 'fa-arrow-circle-up'   },
        { id: 'expense', label: 'Expense Tax', icon: 'fa-minus-circle'       },
    ];

    const handleExport = (format) => {
        const activeCols = columns[activeSubTab] || [];
        const headers = activeCols;
        const rows = []; // Mock data for now

        const title = `Tax Report - ${activeSubTab}`;
        const filename = `tax_report_${activeSubTab}`;

        if (format === 'CSV') exportToCSV(headers, rows, filename);
        else if (format === 'Excel') exportToExcel(headers, rows, filename);
        else if (format === 'PDF') exportToPDF(title, headers, rows, filename);
        else if (format === 'Print') printPage();
    };

    // Column definitions per sub-tab
    const columns = {
        input:   ['Date', 'Reference No', 'Supplier', 'Tax Number', 'Total Amount', 'Payment Method', 'Discount'],
        output:  ['Date', 'Reference No', 'Customer', 'Tax Number', 'Total Amount', 'Payment Method', 'Tax'],
        expense: ['Date', 'Reference No', 'Note',     'Tax Number', 'Total Amount', 'Payment Method', 'Tax'],
    };

    return (
        <div style={{ paddingTop: '0.5rem' }}>

            {/* ── Overall Tax Summary card ── */}
            <div style={{
                background: '#fff',
                border: '1px solid #e2e8f0',
                borderRadius: '10px',
                padding: '1.25rem 1.5rem',
                marginBottom: '1.25rem',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            }}>
                <span style={{ color: '#64748b', fontSize: '0.95rem' }}>
                    Overall (Input − Output − Expense):
                </span>
                <span style={{ color: '#ef4444', fontWeight: '600', fontSize: '1.05rem' }}>
                    $ -66.49
                </span>
                <i className="fa fa-info-circle" style={{ color: '#0ea5e9', marginLeft: '0.25rem' }} />
            </div>

            {/* ── Sub-tabs ── */}
            <div style={{ display: 'flex', gap: 0, borderBottom: '1px solid #e2e8f0', marginBottom: '1rem', flexWrap: 'wrap' }}>
                {subTabs.map(tab => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveSubTab(tab.id)}
                        style={{
                            padding: '0.75rem 1rem',
                            background: 'none',
                            border: 'none',
                            borderBottom: activeSubTab === tab.id ? '2px solid #3b82f6' : '2px solid transparent',
                            color: activeSubTab === tab.id ? '#3b82f6' : '#64748b',
                            fontWeight: activeSubTab === tab.id ? '600' : '500',
                            fontSize: '0.875rem',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                        }}
                    >
                        <i className={`fa ${tab.icon}`} />
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* ── Main table card ── */}
            <div style={{
                background: '#fff',
                border: '1px solid #e2e8f0',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            }}>

                {/* ── Filter row (date range + Search button) ── */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    padding: '1rem 1.25rem',
                    borderBottom: '1px solid #e2e8f0',
                    flexWrap: 'wrap',
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <label style={{ fontSize: '0.8125rem', color: '#64748b', whiteSpace: 'nowrap' }}>From:</label>
                        <input
                            type="date"
                            value={dateFrom}
                            onChange={e => setDateFrom(e.target.value)}
                            style={{
                                padding: '0.4rem 0.75rem',
                                border: '1px solid #e2e8f0',
                                borderRadius: '6px',
                                fontSize: '0.8125rem',
                                outline: 'none',
                                color: '#334155',
                            }}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <label style={{ fontSize: '0.8125rem', color: '#64748b', whiteSpace: 'nowrap' }}>To:</label>
                        <input
                            type="date"
                            value={dateTo}
                            onChange={e => setDateTo(e.target.value)}
                            style={{
                                padding: '0.4rem 0.75rem',
                                border: '1px solid #e2e8f0',
                                borderRadius: '6px',
                                fontSize: '0.8125rem',
                                outline: 'none',
                                color: '#334155',
                            }}
                        />
                    </div>
                    <button
                        style={{
                            padding: '0.4rem 1rem',
                            background: '#3b82f6',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '6px',
                            fontSize: '0.8125rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.4rem',
                        }}
                        onMouseEnter={e => e.currentTarget.style.background = '#2563eb'}
                        onMouseLeave={e => e.currentTarget.style.background = '#3b82f6'}
                    >
                        <i className="fa fa-search" />
                        Search
                    </button>
                </div>

                {/* ── Table controls (Show entries / Export / Search) ── */}
                <div className="table-controls" style={{ borderBottom: '1px solid #e2e8f0', padding: '0.75rem 1.25rem' }}>
                    <div className="table-controls-left">
                        <div className="entries-select">
                            <span>Show</span>
                            <select value={entriesPerPage} onChange={e => setEntriesPerPage(Number(e.target.value))}>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                            <span>entries</span>
                        </div>
                    </div>

                    <div className="table-controls-right">
                        {/* Export dropdown */}
                        <div className="export-dropdown-container" style={{ position: 'relative' }}>
                            <button
                                className="export-btn"
                                onClick={() => setShowExportDropdown(!showExportDropdown)}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: '0.4rem',
                                    padding: '0.4rem 0.8rem', border: '1px solid #e2e8f0',
                                    borderRadius: '6px', background: '#fff', cursor: 'pointer',
                                    fontSize: '0.85rem', color: '#334155',
                                }}
                            >
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="7 10 12 15 17 10" />
                                    <line x1="12" y1="15" x2="12" y2="3" />
                                </svg>
                                Export ▾
                            </button>
                            {showExportDropdown && (
                                <div className="export-dropdown-menu" style={{
                                    position: 'absolute', top: '100%', right: 0, marginTop: '0.25rem',
                                    background: '#fff', border: '1px solid #e2e8f0', borderRadius: '6px',
                                    boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', zIndex: 10, minWidth: '160px',
                                }}>
                                    {[
                                        { icon: 'fa-file-excel-o', label: 'Export CSV', action: () => handleExport('CSV') },
                                        { icon: 'fa-file-excel-o', label: 'Export Excel', action: () => handleExport('Excel') },
                                        { icon: 'fa-print',        label: 'Print', action: () => handleExport('Print') },
                                        { icon: 'fa-table',        label: 'Column visibility' },
                                        { icon: 'fa-file-pdf-o',   label: 'Export PDF', action: () => handleExport('PDF') },
                                    ].map((item, i) => (
                                        <button
                                            key={i}
                                            onClick={() => { if (item.action) item.action(); setShowExportDropdown(false); }}
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: '0.5rem',
                                                width: '100%', padding: '0.5rem 1rem', border: 'none',
                                                background: 'none', textAlign: 'left', cursor: 'pointer',
                                                fontSize: '0.8125rem', color: '#475569',
                                            }}
                                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f1f5f9'}
                                            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                        >
                                            <i className={`fa ${item.icon}`} style={{ width: '14px', textAlign: 'center' }} />
                                            {item.label}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Search */}
                        <input
                            type="text"
                            placeholder="Search ..."
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            style={{
                                padding: '0.4rem 0.75rem',
                                border: '1px solid #e2e8f0',
                                borderRadius: '6px',
                                fontSize: '0.8125rem',
                                outline: 'none',
                                width: '180px',
                            }}
                        />
                    </div>
                </div>

                {/* ── Data table ── */}
                <div style={{ overflowX: 'auto' }}>
                    <table className="products-table" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                        <thead>
                            <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                                {(columns[activeSubTab] || []).map(col => (
                                    <th key={col} style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600' }}>
                                        {col} <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} />
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td
                                    colSpan={(columns[activeSubTab] || []).length}
                                    style={{ textAlign: 'center', padding: '2.5rem', color: '#94a3b8', fontSize: '0.9rem' }}
                                >
                                    No data available in table
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* ── Pagination ── */}
                <div className="pagination" style={{ padding: '0.85rem 1.25rem', borderTop: '1px solid #e2e8f0' }}>
                    <div className="pagination-info" style={{ fontSize: '0.8125rem' }}>
                        Showing 0 to 0 of 0 entries
                    </div>
                    <div className="pagination-controls">
                        <button className="page-btn disabled">Previous</button>
                        <button className="page-btn active">1</button>
                        <button className="page-btn disabled">Next</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TaxReport;
